/**
 * Law firms listed on /find-a-lawyer. Source: docs/research/law-firms.json (verified 2026-11-03
 * from each firm's own site). Alphabetical, not ranked. NO phone numbers are published here because
 * most could not be verified. Harter Secrest & Emery omitted (only source was a 2017 press release).
 *
 * LEGAL/ACCURACY GATE: the page states we have no affiliation or commercial relationship with these
 * firms. Keep that statement TRUE: if InventiveHQ ever gets a referral fee, shares clients, or has
 * any other relationship with a listed firm, remove the firm or change the wording. Counsel should
 * review this list (attorney-advertising rules, implied endorsement) before it goes public.
 */
export interface FirmListing { name: string; url: string; says: string; smb: boolean; tie: string | null }
export const FIRMS_VERIFIED_ON = "2026-11-03"
export const LAW_FIRMS: FirmListing[] = [
  {
    "name": "BakerHostetler",
    "url": "https://www.bakerlaw.com/services/digital-assets-and-data-management/",
    "says": "Says its Digital Assets and Data Management group advises on 'responses to data security incidents of all kinds'; publishes an annual Data Security Incident Response Report (2026 edition released Mar 26, 2026 per firm site search result).",
    "smb": true,
    "tie": null
  },
  {
    "name": "Clark Hill",
    "url": "https://www.clarkhill.com/services/practice/cybersecurity-data-protection-privacy/",
    "says": "Page lists a '24/7 Breach Hotline'; covers privacy regimes such as CCPA, GDPR, NYDFS, HIPAA.",
    "smb": false,
    "tie": null
  },
  {
    "name": "Connell Foley",
    "url": "https://connellfoley.com/practices-cyber-security-and-data-privacy",
    "says": "Says it serves as breach response counsel and will assess federal, state and local obligations, draft consumer and attorney-general notices and liaise with federal law enforcement; 24/7 hotline.",
    "smb": false,
    "tie": "Says it is an authorized NetDiligence Breach Coach firm and works with cyber insurance carriers."
  },
  {
    "name": "Constangy",
    "url": "https://www.constangy.com/services/Cybersecurity-Data-Privacy",
    "says": "Says its Cyber Team handles breach notification requirements, hotline management and provides 24/7 availability; offers an interactive state breach-law map.",
    "smb": false,
    "tie": "Says its team is a preferred provider for more than 70 cyber insurance carriers."
  },
  {
    "name": "Greenberg Traurig",
    "url": "https://gtlaw.com/en/capabilities/data-privacy-cybersecurity/data-breach-incident-response",
    "says": "Says its team has helped clients prepare for, respond to and litigate data breaches, including phishing, ransomware and inadvertent disclosure; 24/7 Data Breach Hotline.",
    "smb": true,
    "tie": null
  },
  {
    "name": "Hodgson Russ",
    "url": "https://www.hodgsonruss.com/newsroom/news/hodgson-russ-llp-named-authorized-breach-coach-law-firm-by-netdiligence",
    "says": "Press release (2025-07-28) says its Cybersecurity & Privacy Practice offers 24-hour incident response and breach notification and was named a NetDiligence Breach Coach firm.",
    "smb": false,
    "tie": "Holds a NetDiligence Breach Coach designation."
  },
  {
    "name": "Husch Blackwell",
    "url": "https://www.huschblackwell.com/industries_services/data-privacy-and-cybersecurity",
    "says": "Describes data privacy and cybersecurity practice including incident response, breach counseling and regulatory defense; breach response covers notification, insurance coverage, regulatory reporting and communications.",
    "smb": false,
    "tie": null
  },
  {
    "name": "Lewis Brisbois",
    "url": "https://lewisbrisbois.com/24-7-rapid-response/data-breach-response",
    "says": "Advertises a '24/7 Data Breach Response' rapid response service.",
    "smb": false,
    "tie": null
  },
  {
    "name": "McDonald Hopkins",
    "url": "https://www.mcdonaldhopkins.com/services/Data-privacy-and-cybersecurity/Breach-coaching-and-incident-notification",
    "says": "Says it provides incident response legal services, develops a customized plan on notification, and helps with state, federal, international and industry breach-notice laws.",
    "smb": false,
    "tie": "Describes itself as a NetDiligence Breach Coach firm."
  },
  {
    "name": "Mullen Coughlin",
    "url": "https://www.mullen.law/",
    "says": "Site lists Breach Response described as '24/7 Crisis Management Services' with a 'Breach Hotline'.",
    "smb": false,
    "tie": null
  },
  {
    "name": "Nelson Mullins",
    "url": "https://www.nelsonmullins.com/services/cybersecurity_and_data_breach_response",
    "says": "Says it coaches clients through incidents, coordinates forensics, handles notifications to affected parties and regulators, and defends related investigations and class actions; says it is available around the clock.",
    "smb": true,
    "tie": null
  },
  {
    "name": "Wilson Elser",
    "url": "https://www.wilsonelser.com/services/27-cybersecurity_data_privacy",
    "says": "Describes cyber risk management, breach response including notification letters tailored to differing state requirements, and representation before state AGs, HHS OCR and FBI; lists 24/7 incident response hotlines but publishes no number.",
    "smb": true,
    "tie": "Also acts as coverage and monitoring counsel for insurance carriers on cyber claims."
  }
]
